import { Routes } from '@angular/router';
import { ProfileComponent } from './pages/profile/profile.component';
import { BasicProfileComponent } from './pages/profile/basic-profile/basic-profile.component';

export const routes: Routes = [
  {
    path: 'home',
    loadComponent: () => import('./pages/home/home.component').then(c => c.HomeComponent)
  },
  {
    path: 'categories',
    loadComponent: () => import('./pages/category-page/category-page.component').then(c => c.CategoryPageComponent)
  },
  {
    path: 'all-courses',
    loadComponent: () => import('./pages/all-courses/all-courses.component').then(c => c.AllCoursesComponent)
  },
  {
    path: 'product-detail',
    loadComponent: () => import('./pages/product-detail/product-detail.component').then(c => c.ProductDetailComponent)
  },
  {
    path: 'profile',
    component: ProfileComponent,
    children: [
      {
        path: '',  // Default route, redirects to basic profile
        pathMatch: 'full',
        redirectTo: 'basic'
      },
      {
        path: 'basic',
        loadComponent: () => import('./pages/profile/basic-profile/basic-profile.component').then(c => BasicProfileComponent)
      },
      {
        path: 'advanced',
        loadComponent: () => import('./pages/profile/basic-profile/basic-profile.component').then(c => BasicProfileComponent)
      },
      {
        path: 'company',
        loadComponent: () => import('./pages/profile/basic-profile/basic-profile.component').then(c => BasicProfileComponent)
      },
      {
        path: 'settings',
        loadComponent: () => import('./pages/profile/basic-profile/basic-profile.component').then(c => BasicProfileComponent)
      },
    ]
  },
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./pages/home/home.component').then(c => c.HomeComponent)
  },
];
